export const getHumanizerWordsBalance = (): number => {
  const BALANCE = {
    standard: 80000,
  };

  return BALANCE.standard;
};

export const getHumanizerInputLimits = (data: {
  isLongHumanizer: boolean;
}): {
  minCount: number;
  maxCount: number;
} => {
  const { isLongHumanizer } = data;

  const LIMITS = {
    standard_min: 65,
    standard_max: 1800,
    own_long: 5000,
  };

  return {
    minCount: LIMITS.standard_min,
    maxCount: isLongHumanizer ? LIMITS.own_long : LIMITS.standard_max,
  };
};
